import { render, staticRenderFns } from "./Funnel.vue?vue&type=template&id=ee4e2b8c&scoped=true"
import script from "./Funnel.vue?vue&type=script&lang=js"
export * from "./Funnel.vue?vue&type=script&lang=js"
import style0 from "./Funnel.vue?vue&type=style&index=0&id=ee4e2b8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4e2b8c",
  null
  
)

export default component.exports